import { postData } from "./rest-api-helper"

export async function trkOpReptPdf({ filterObj, columns }) {
    const details = {
        urlPath: "/pdf/trkOpRept",
        body: {
            filterObj: { ...filterObj }, columns: [...columns]
        }
    }
    // console.log(details)
    const res = await postData(details);
    return res
}

export async function shipmtReptPdf({ filterObj, columns }) {
    const details = {
        urlPath: "/pdf/shipmtRept",
        body: {
            filterObj: { ...filterObj }, columns: [...columns]
        }
    }
    // console.log(details)
    const res = await postData(details);
    return res
}

export async function tpReqPymtReptPdf({ filterObj, columns }) {
    const details = {
        urlPath: "/pdf/tpReqPymtRept",
        body: {
            filterObj: { ...filterObj }, columns: [...columns]
        }
    }
    // console.log(details)
    const res = await postData(details);
    return res
}

export async function trkOpLedgerPdf({ truckopId, fromDate, toDate, partyName }) {
    const details = {
        urlPath: "/pdf/trkOpLedger",
        body: { truckopId, fromDate, toDate, partyName }
    }
    const res = await postData(details);
    return res
}

export async function custLedgerPdf({ custId, fromDate, toDate, partyName }) {
    const details = {
        urlPath: "/pdf/custLedger",
        body: { custId, fromDate, toDate, partyName }
    }
    const res = await postData(details);
    return res
}

export async function adminAgentPdf({ filterObj, columns }) {
    const details = {
        urlPath: "/pdf/adminAgentRept",
        body: {
            filterObj: { ...filterObj }, columns: [...columns]
        }
    }
    // console.log(details)
    const res = await postData(details);
    return res
}

export async function genCustReqRept({ filterObj, columns }) {
    const details = {
        urlPath: "/pdf/genCustReqRept",
        body: {
            filterObj: { ...filterObj }, columns: [...columns]
        }
    }
    // console.log(details)
    const res = await postData(details);
    return res
}

export async function genFuelCoupon(body) {
    const details = {
        urlPath: "/pdf/genFuelCoupon",
        body: { ...body }
    }
    const res = await postData(details);
    return res
}

export async function genTrkOpReqRept({ filterObj, columns }) {
    const details = {
        urlPath: "/pdf/genTrkOpReqRept",
        body: {
            filterObj: { ...filterObj }, columns: [...columns]
        }
    }
    // console.log(details)
    const res = await postData(details);
    return res
}